import React from "react"

import FieldFormElementView, {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import {
    DateRangeRelativePeriod,
    DateRangeRelativePeriodValue,
    DateRangeRelativity,
    RELATIVE_PERIOD_DEFAULT_VALUE
} from "../date-range-relative-period"
import {FieldType} from "../../../../field-type"
import FieldsFactory from "../../../../fields-factory";

// const debug = "FieldDateRangeRelativePeriod_FormElementView"
const debug = false

export default function FieldDateRangeRelativePeriod_FormElementView(props: FieldFormElementViewProps) {
    const curModelValue = props.field.getViewValue(props.model)

    debug && console.log(debug, 'render', curModelValue, props)

    const value : DateRangeRelativePeriodValue = curModelValue ?
        _.clone(curModelValue) // we dont want issues with object references
        :
        RELATIVE_PERIOD_DEFAULT_VALUE

    const onRelativityChange = (relativity:DateRangeRelativity) => {
        value.relativity = relativity
        if (props.onChange) props.onChange(value)
    }

    const onPeriodChange = (period:DateRangeRelativePeriod) => {
        value.period = period
        if (props.onChange) props.onChange(value)
    }

    const fieldRelativity = FieldsFactory.get({
        type            : FieldType.DROPDOWN,
        fieldId         : 'relativity',
        options         : [
            {label: 'This',     value: DateRangeRelativity.THIS},
            {label: 'Last',     value: DateRangeRelativity.LAST},
        ],
        noValueOption   : false,
        showMenuMore    : false,
    })

    const fieldPeriod = FieldsFactory.get({
        type            : FieldType.DROPDOWN,
        fieldId         : 'period',
        options         : [
            {label: 'Week',     value: DateRangeRelativePeriod.WEEK},
            {label: 'Month',    value: DateRangeRelativePeriod.MONTH},
            {label: 'Year',     value: DateRangeRelativePeriod.YEAR}
        ],
        noValueOption   : false,
        showMenuMore    : false,
    })

    return (
        <div className={Classes("flex-row-left-center", props.className)}>
            <FieldFormElementView className = "w-140"
                                  field     = {fieldRelativity}
                                  model     = {value}
                                  onChange  = {onRelativityChange}/>
            <FieldFormElementView className = "w-140 m-l-10"
                                  field     = {fieldPeriod}
                                  model     = {value}
                                  onChange  = {onPeriodChange} />
        </div>
    )
}